<template>
<div class="chapter">
<div class="inner_page">
<p class="copy"> </p>
<p class="copy"> </p>
<p class="copy"> </p>
<p class="copy">First published in paperback in Great Britain in 2023 by<br/>Polygon, an imprint of Birlinn Ltd.</p>
<p class="copy1">Birlinn Ltd</p>
<p class="copy">West Newington House</p>
<p class="copy">10 Newington Road</p>
<p class="copy">Edinburgh EH9 1QS</p>
<p class="copy1"><a href="http://www.polygonbooks.co.uk" target="_blank">www.polygonbooks.co.uk</a></p>
<p class="copy1">Copyright © Jim Carruth, 2023</p>
<p class="copy1"><span class="small">ISBN</span> 978 1 84697 636 0</p>
<p class="copy"><span class="small">EBOOK ISBN</span> 978 1 78885 578 5</p>
<p class="copy1">The moral right of Jim Carruth to be identified as the<br/>author of this work has been asserted in<br/>accordance with the Copyright, Designs<br/>and Patents Act, 1988.</p>
<p class="copy1"><em>British Library Cataloguing-in-Publication Data</em><br/>A catalogue record for this book is available on<br/>request from the British Library.</p>
<p class="copyi"><img alt="Illustration" src="images/copy.jpg"/></p>
<p class="copy1">The publisher gratefully acknowledges investment from<br/>Creative Scotland towards the publication of this book.</p>
<p class="copy1">Typeset in Verdigris mvb by The Foundry, Edinburgh<br/>Printed and bound in Great Britain by Clays Ltd, Elcograf S.p.A.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?2247c7e2